import { useState } from "react";
import { Button, Popover, Whisper, Input } from "rsuite";
import Item from "./Components/Item/Item";
import styles from "./ItemsBlock.module.css";
import { isAttachedFilesBlockAvaliable } from "../../../../../helperFunctions";
//import { IoDocumentTextOutline } from 'react-icons/io5';
//import FilesUploader from './Components/FilesUploader/FilesUploader';
import { useItemsBlock } from "./useItemsBlock";
import CloseIcon from "@rsuite/icons/Close";

function ItemsBlock({
  readonly,
  formMode,
  itemsTitles,
  invoiceItems,
  invoiceId,
}) {
  const {
    addItem,
    deleteItem,
    itemHandler,
    addHeader,
    deleteHeader,
    onUpdateTitle,
  } = useItemsBlock();

  const addButton = (
    <>
      <Button
        disabled={readonly}
        onClick={() => addItem()}
        appearance="primary"
        style={{ width: 100, margin: "0px 0px 55px 0px" }}
      >
        Add Item
      </Button>
    </>
  );

  // const ItemsHeader = ({ itemsTitles, formMode }) => {
  // 	let itemsHeader;

  // 	const aveWidth = Math.round(890 / itemsTitles.length - 40);

  // 	if (formMode === 'create') {
  // 		itemsHeader = (
  // 			<>
  // 				<div key='title1' style={{ width: '105px' }}>
  // 					{itemsTitles[0]}
  // 				</div>
  // 				<div key='title2' style={{ width: '205px' }}>
  // 					{itemsTitles[1]}
  // 				</div>
  // 				<div key='title3' style={{ width: '70px' }}>
  // 					{itemsTitles[2]}
  // 				</div>
  // 				<div key='title4' style={{ width: '70px' }}>
  // 					{itemsTitles[3]}
  // 				</div>
  // 				<div key='title5' style={{ width: '110px' }}>
  // 					{itemsTitles[4]}
  // 				</div>
  // 				<div key='title6' style={{ width: '110px' }}>
  // 					{itemsTitles[5]}
  // 				</div>
  // 				<div key='title7' style={{ width: '40px' }}></div>
  // 			</>
  // 		);
  // 	} else {
  // 		itemsHeader = itemsTitles.map((element, index) => (
  // 			<div key={index} style={{ width: aveWidth }}>
  // 				{element}
  // 			</div>
  // 		));
  // 	}
  // 	return itemsHeader;
  // };
  const ItemsHeader = ({
    itemsTitles,
    formMode,
    onUpdateTitle,
    onAddHeader,
    onDeleteHeader,
  }) => {
    const [editingIndex, setEditingIndex] = useState(null);
    const [titleValue, setTitleValue] = useState("");

    const handleEditClick = (index) => {
      setEditingIndex(index);
      setTitleValue(itemsTitles[index]);
    };

    const handleSave = (index) => {
      onUpdateTitle(index, titleValue);
      setEditingIndex(null);
    };

    const aveWidth = Math.round(920 / itemsTitles.length);

    return (
      <>
        {itemsTitles.map((title, index) => (
          <div
            key={index}
            className={styles.headerItem}
            style={{ width: aveWidth, position: "relative" }}
          >
            {editingIndex === index ? (
              <Input
                value={titleValue}
                onChange={(value) => setTitleValue(value)}
                onBlur={() => handleSave(index)}
                autoFocus
              />
            ) : (
              <span onClick={() => handleEditClick(index)}>{title}</span>
            )}

            {/* Add Icon */}
            <div
              className={`${styles.addIcon}`}
              onClick={() => onAddHeader(index)}
              style={{
                position: "absolute",
                top: -15,
                right: 40,
                cursor: "pointer",
                color: "green",
              }}
            >
              ＋
            </div>

            {/* Delete Icon ✖ */}
            <CloseIcon
              className={`${styles.deleteIcon}`}
              onClick={() => onDeleteHeader(index)}
              style={{
                position: "absolute",
                top: -13,
                right: 15,
                cursor: "pointer",
                color: "red",
                width: 12,
              }}
            />
            {/* <div
              className={`${styles.deleteIcon}`}
              onClick={() => onDeleteHeader(index)}
              style={{
                position: "absolute",
                top: -20,
                right: 5,
                cursor: "pointer",
                color: "red",
              }}
            >
              ✖
            </div> */}
          </div>
        ))}
        {/* <div style={{ width: '30px', cursor: 'pointer' }} onClick={() => onAddHeader(itemsTitles.length)}>
					+
				</div> */}
      </>
    );
  };

  return (
    <>
      <div key="invoice_titles" className={styles.container}>
        <div className={styles.titles}>
          <ItemsHeader
            itemsTitles={itemsTitles}
            onUpdateTitle={onUpdateTitle}
            formMode={formMode}
            onAddHeader={addHeader}
            onDeleteHeader={deleteHeader}
          />
        </div>
        {/* <ItemsArr itemsObject={invoiceItems} formMode={formMode} onChange={itemHandler} /> */}
        {invoiceItems.map((item, rowIndex) => (
          <>
            <Item
              readonly={readonly}
              rowIndex={rowIndex}
              item={item}
              onChange={itemHandler}
              formMode={formMode}
              onDelete={() => deleteItem(rowIndex)}
            />
          </>
        ))}

        <div className={styles.buttons}>{addButton}</div>
      </div>
    </>
  );
}

export default ItemsBlock;
